import type { IVehicle } from '@makemydeal/dr-platform-types';
import type { CatalogVehicle } from '../types';

export const getFilteredSearchResults = (vin?: string, stockNumber?: string, vehicles?: (IVehicle | CatalogVehicle)[]) => {
    if ((!vin && !stockNumber) || !vehicles) {
        return { filteredSearchResults: vehicles, isFilteredSearchError: false };
    }

    // Deliberately AND, not OR (unlike getFilteredAISearchResults in agentUtils.ts): this file's results span
    // cross-dealership search, and stock numbers are dealer-scoped, not globally unique — a stockNumber-only
    // match here can exclude the wrong vehicle at a different rooftop. Confirmed by open-deal's own fixtures
    // (changeVehicleResponses.ts), which share one stockNumber across vehicles that differ only by vin.
    const filteredSearchResults = vehicles.filter((vehicle) => !(vehicle.vin === vin && vehicle.stockNumber === stockNumber));

    return {
        filteredSearchResults,
        isFilteredSearchError: !filteredSearchResults.length && vehicles.length !== filteredSearchResults.length
    };
};

export const mapToOptions = <T extends Record<string, string>>(optionsMap: T) =>
    Object.entries(optionsMap).map(([value, label]) => ({ value, label }));
